var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"portal-content-wrap ptBG2"},[_c('div',{staticClass:"maxWidth"},[_c('div',{staticClass:"wpart",style:(_vm.webpartStyle)},[_c('div',{staticClass:"wpart-template"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }